import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreenRounded";
import OpenInFullIcon from "@mui/icons-material/OpenInFullRounded";
import { IconButton } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPreviewMode } from "../../../store/selectors/currentReportSelectors";
import { createCurrentReportAction } from "../../../store/utils/storeUtils";

export default function ChangePreviewModeButton() {
  const dispatch = useDispatch();
  const previewMode = useSelector(selectPreviewMode);

  const handleUpdatePreviewMode = React.useCallback(() => {
    dispatch(createCurrentReportAction("updatePreviewMode", previewMode === "default" ? "maximize" : "default"));
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [previewMode]);

  return (
    <IconButton onClick={handleUpdatePreviewMode}>
      {previewMode === "default" && (
        <OpenInFullIcon sx={(theme) => ({ "&:hover": { color: theme.palette.primary.main } })} />
      )}
      {previewMode === "maximize" && (
        <CloseFullscreenIcon sx={(theme) => ({ "&:hover": { color: theme.palette.primary.main } })} />
      )}
    </IconButton>
  );
}
